
// // GSAP + ScrollTrigger animation logic
// gsap.registerPlugin(ScrollTrigger);

// // Step 1: Pin the section
// ScrollTrigger.create({
//   trigger: ".headerSecWrap",
//   start: "top top",
//   end: "+=650px",
//   pin: true,
//   // markers: true, // uncomment for debugging
// });

// // Step 2: Create timeline to fade header-wrapper with scroll
// let headerFadeTL = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".header",
//     start: "top top",
//     end: "+=650px",
//     scrub: true,
//     // markers: true,
//   }
// });

// headerFadeTL.to([".header-wrapper", ".hero-text"], {
//   opacity: 0,
//   ease: "none"
// });

// // Step 3: Slide in checkoutBar after header fade
// gsap.from(".checkoutBar", {
//   y: -100,
//   opacity: 0,
//   duration: 0.5,
//   ease: "power2.out",
//   scrollTrigger: {
//     trigger: ".headerSecWrap",
//     start: "top+=650", // fires when the header fade completes
//     toggleActions: "play none none reverse",
//     // markers: true,
//   },
// });


// Header and Cart Gsap new version
gsap.registerPlugin(ScrollTrigger);

// Scroll-triggered opposite slide animation
ScrollTrigger.create({
  trigger: ".headerSecWrap",
  start: "top top",
  end: "+=100px",
  scrub: true,
  onUpdate: (self) => {
    if (self.progress > 0.2) {
      // Header slides up
      gsap.to(".header-wrapper", {
        y: -100,
        opacity: 0,
        duration: 0.4,
        ease: "power2.inOut",
      });

      // Cart slides down
      gsap.to(".checkoutBar", {
        y: 0,
        opacity: 1,
        width: "95%",
        duration: 0.4,
        ease: "power2.inOut",
      });
    } else {
      // Reset header
      gsap.to(".header-wrapper", {
        y: 0,
        opacity: 1,
        duration: 0.4,
        ease: "power2.inOut",
      });

      // Hide cart again
      gsap.to(".checkoutBar", {
        y: -800,
        opacity: 0,
        width: "75%",
        duration: 0.4,
        ease: "power2.inOut",
      });
    }
  },
});








// Select all FAQ items
const faqItems = document.querySelectorAll('.faq-item');

// Loop through each FAQ item
faqItems.forEach((item) => {
  // Add dynamic icons to each question button
  const icon = document.createElement('span');
  icon.classList.add('icon');
  icon.textContent = '+'; // Initial icon
  item.querySelector('.faq-question').appendChild(icon);

  // Add click event listener
  item.querySelector('.faq-question').addEventListener('click', () => {
    // Close any other open FAQ items
    faqItems.forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.classList.remove('active');
        otherItem.querySelector('.icon').textContent = '+';
        otherItem.querySelector('.faq-answer').style.maxHeight = null;
      }
    });

    // Toggle the current FAQ item
    const isActive = item.classList.contains('active');
    if (isActive) {
      item.classList.remove('active');
      icon.textContent = '+';
      item.querySelector('.faq-answer').style.maxHeight = null;
    } else {
      item.classList.add('active');
      icon.textContent = '-';
      item.querySelector('.faq-answer').style.maxHeight =
        item.querySelector('.faq-answer').scrollHeight + 'px';
    }
  });
});

